import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-admission',
  templateUrl: './about-admission.component.html',
  styleUrls: ['./about-admission.component.scss']
})
export class AboutAdmissionComponent implements OnInit {

  public relPath:string = "./../../../../assets/Contents/imgs/admission/";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-admission/about-admission.component.ts